/* istanbul ignore file */
/**
 * Created by rathompson on 11/3/21
 * File: DescriptionRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Body } from '@panwds/react-ui'
import type { VFC } from 'react'
import type { RowInstance } from '@panwds/react-table'
import type { IAM_Role } from '../../../../../common/reducers/types/IAMReducer.types'

/**
 *   Permission description table cell
 */
const DescriptionRenderer: VFC<{
  row: RowInstance<IAM_Role>,
  value: string
}> = ({ row, value }) => {
  return (
    <div className='tw-whitespace-normal tw-w-full'>
      <Body size="lg">{value}</Body>
    </div>
  )
}

DescriptionRenderer.propTypes = {}
export default DescriptionRenderer
